import { Component } from '@angular/core';

@Component({
  selector: 'kyc-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrl: './skeleton.component.scss',
})
export class SkeletonComponent {}
